import jwt_decode from "jwt-decode";

export const JWT_ACCESS_TOKEN = "jwtAccessToken";
export const USER_ID = "userId";
// Auth0 originally issued the roles claim with a double slash. Newer tokens use
// the normalized, single-slash namespace. Support both while existing sessions
// and Auth0 environments are migrated.
export const NAMESPACE = "https://upload.kaliber.ai/roles";
export const LEGACY_NAMESPACE = "https://upload.kaliber.ai//roles";
export const ROLE_DOCTOR = "Doctor";
export const ROLE_KALIBER_ADMIN = "Kaliber Admin";
export const PERMISSION_CREATE_VIDEOS = "create:videos";

export const setAuthToken = (accessToken) => {
  localStorage.setItem(JWT_ACCESS_TOKEN, accessToken);
};

export const setUserId = (userId) => {
  localStorage.setItem(USER_ID, userId);
};

export const isKaliberAdminOrDoctor = (accessToken) => {
  // Return false if the access token is empty
  if (!accessToken) {
    return false;
  }
  try {
    const decoded = jwt_decode(accessToken);
    const roles = decoded[NAMESPACE] || decoded[LEGACY_NAMESPACE];
    const permissions = decoded.permissions;

    return (
      (Array.isArray(roles) &&
        (roles.includes(ROLE_DOCTOR) || roles.includes(ROLE_KALIBER_ADMIN))) ||
      (Array.isArray(permissions) &&
        permissions.includes(PERMISSION_CREATE_VIDEOS))
    );
  } catch (error) {
    return false;
  }
};
